import type { Dtos } from "@inrev/common";
import { useAdminFetchAdminUsers } from "@portal/api/admin-user/admin";
import type { FC } from "react";
import { Avatar, AvatarGroup } from "../../primitives";

const EMPTY_ADMIN_USERS: Dtos.Admin.AdminUser.Get.Response[] = [];

export type AssigneeAvatarsProps = {
	assigneeIds: string[];
};

export const AssigneeAvatars: FC<AssigneeAvatarsProps> = ({ assigneeIds }) => {
	const { adminUsers = EMPTY_ADMIN_USERS } = useAdminFetchAdminUsers();

	if (assigneeIds.length === 0) return null;

	return (
		<AvatarGroup data-testid="assignee-avatars">
			{assigneeIds.map((assigneeId) => {
				const assignee = adminUsers.find((user) => user.id === assigneeId);

				return (
					<Avatar key={assigneeId} firstName={assignee?.firstName} lastName={assignee?.lastName} />
				);
			})}
		</AvatarGroup>
	);
};
